/**
 * Shared date utilities used across PriceList info components.
 */

/**
 * Formats a Date object as "DD/MM/YYYY".
 * Used as the `formatDate` prop of Fluent UI v8 DatePicker.
 */
export const onFormatDate = (date?: Date): string => {
  if (!date) return '';
  return (
    date.getDate().toString().padStart(2, '0') +
    '/' +
    (date.getMonth() + 1).toString().padStart(2, '0') +
    '/' +
    date.getFullYear().toString()
  );
};

/**
 * Parses a UTC ISO date string as a local date without timezone shift.
 * The API stores dates as UTC midnight (e.g. "2026-01-01T00:00:00Z").
 * Using `new Date(str)` would shift it to 31/12/2025 in UTC-3.
 * This function treats the date portion as local.
 */
export const parseUTCDateAsLocal = (value: Date | string | undefined | null): Date | undefined => {
  if (!value) return undefined;
  const str = typeof value === 'string' ? value : value.toISOString();
  // Take only the date part (YYYY-MM-DD) and parse as local midnight
  const datePart = str.slice(0, 10); // "2026-01-01"
  const [year, month, day] = datePart.split('-').map(Number);
  return new Date(year, month - 1, day);
};

/**
 * Serializes a Date selected by the user (local time) as a UTC midnight ISO string.
 * Avoids offset shift by using the local date components.
 */
export const serializeDateForAPI = (date: Date): string => {
  const y = date.getFullYear();
  const m = (date.getMonth() + 1).toString().padStart(2, '0');
  const d = date.getDate().toString().padStart(2, '0');
  return `${y}-${m}-${d}T00:00:00Z`;
};
